import { get, getAuthenticatedRequestConfig } from '../client'
import { notificationsIndexSerializer } from '../../serializers/getNotificationsIndexSerializer'

export const getNotificationsIndexResource = (params = {}) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  get('/v1/notifications', { ...params })
    .then((response) => notificationsIndexSerializer(response))
    .catch((error) => Promise.reject(error))

export const getAuthencatedNotificationsIndexResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return getNotificationsIndexResource(requestConfig)
}

export default getNotificationsIndexResource
